import { Box } from '@chakra-ui/layout'
import { Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import numeral from 'numeral'
import type { AnalyticsAPIResponse } from '../../interfaces'
import ScrollableTable from './ScrollableTable'

interface Props {
  data: AnalyticsAPIResponse
  showBandwidth: Boolean
}

const TopCountriesTable = ({
  data,
  showBandwidth,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  const countryData = data.country?.items

  if (!countryData || !Object.keys(countryData).length) {
    return <Box>{t('no_data_available', 'No Data Available')}</Box>
  }

  const tableRows = countryData.map(country => {
    if (!country.name || !country.count) {
      return null
    }

    return (
      <Tr key={country.name}>
        <Td>{`${country.name} ${country.code ? `(${country.code})` : ''}`}</Td>
        <Td>
          {showBandwidth === true
            ? `${numeral(country.count)
                .format('0.0 a')
                .toUpperCase()} requests (${numeral(country.bandwidth)
                .format('0.0 ib')
                .replace('i', '')})`
            : `${numeral(country.count)
                .format('0.0 a')
                .toUpperCase()} requests`}
        </Td>
      </Tr>
    )
  })

  return (
    <ScrollableTable>
      <Thead>
        <Tr>
          <Th>{t('country', 'Country')}</Th>
          <Th>{t('usage', 'Usage')}</Th>
        </Tr>
      </Thead>
      <Tbody>{tableRows}</Tbody>
    </ScrollableTable>
  )
}

export default TopCountriesTable
